module.exports = __webpack_public_path__ + "img/jike.e5423010.png";